import { FIREBASE_STORAGE_BUCKET_PRD } from "./constants";

export enum SoundFileName {
  sceneChangingBaseSound = "sceneChangingSound.mp3",
  birdSingingSound = "ambience_forest_birds_03.wav",
}

const FIREBASE_STORAGE_URL =
  "https://firebasestorage.googleapis.com/v0/b/" + FIREBASE_STORAGE_BUCKET_PRD;

const soundUrl = (filePath: SoundFileName) => {
  const url = `${FIREBASE_STORAGE_URL}/o/sound%2F${encodeURIComponent(
    filePath
  )}?alt=media`;

  return url;
};

export const soundPlay = async (filePath: SoundFileName, volume: number) => {
  const url = soundUrl(filePath);
  const audio = new Audio(url);
  audio.volume = volume;
  console.log(audio.volume);
  await audio.play();
};
